<template>
  <div class="donut-legend-wrap">
    <svg :viewBox="`0 0 ${SIZE} ${SIZE}`" :width="SIZE" :height="SIZE" class="donut-svg">
      <circle
        :cx="CX"
        :cy="CY"
        :r="R"
        fill="none"
        stroke="#f0f0f0"
        :stroke-width="STROKE"
      />
      <circle
        v-for="seg in segments"
        :key="seg.key"
        :cx="CX"
        :cy="CY"
        :r="R"
        fill="none"
        :stroke="seg.color"
        :stroke-width="STROKE"
        :stroke-dasharray="`${seg.dash} ${CIRCUMFERENCE}`"
        :stroke-dashoffset="seg.offset"
        :transform="`rotate(-90 ${CX} ${CY})`"
        stroke-linecap="butt"
        style="transition: stroke-dasharray 0.4s ease;"
      />
      <text
        :x="CX"
        :y="CY - 10"
        text-anchor="middle"
        font-size="28"
        font-weight="700"
        font-family="Inter, sans-serif"
        fill="#1B1D21"
        :style="total > 0 && clickable ? 'cursor:pointer; text-decoration: underline;' : ''"
        @click="total > 0 && clickable && $emit('click-total')"
      >{{ total }}</text>
      <text
        :x="CX"
        :y="CY + 16"
        text-anchor="middle"
        font-size="13"
        font-family="Inter, sans-serif"
        fill="#8593A3"
      >solicitudes</text>
    </svg>

    <div class="legend">
      <div v-for="item in legendItems" :key="item.key" class="legend-item">
        <span class="legend-dot" :style="{ background: item.color }"></span>
        <span class="legend-label">{{ item.label }}</span>
        <span class="legend-value">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
const SIZE = 220;
const CX = SIZE / 2;
const CY = SIZE / 2;
const R = 88;
const STROKE = 30;
const CIRCUMFERENCE = 2 * Math.PI * R;
const GAP = 2;

const STATUS_CONFIG = [
  { key: 'registered',  label: 'Solicitados',   color: '#2196F3' },
  { key: 'inReview',    label: 'En revisión',   color: '#FF9800' },
  { key: 'toCorrect',   label: 'En corrección', color: '#9C27B0' },
  { key: 'invalidPayment', label: 'Pago inválido', color: '#EA580C' },
  { key: 'approved',    label: 'Aprobados',     color: '#4CAF50' },
  { key: 'paid',        label: 'Pagados',        color: '#009688' },
  { key: 'petmed',      label: 'PetMed',        color: '#7B1FA2' },
  { key: 'operational', label: 'Operativos',    color: '#3F51B5' },
  { key: 'rejected',    label: 'Rechazados',    color: '#F44336' },
];

export default {
  name: 'RefundDonutChart',
  props: {
    metrics: { type: Object, default: () => ({}) },
    total:   { type: Number, default: 0 },
    // Sin permiso para ver el listado de reembolsos el total no es un enlace.
    clickable: { type: Boolean, default: true },
  },
  data() {
    return { SIZE, CX, CY, R, STROKE, CIRCUMFERENCE };
  },
  computed: {
    segments() {
      const t = this.total || 1;
      let accumulated = 0;
      return STATUS_CONFIG.map(cfg => {
        const value = (this.metrics && this.metrics[cfg.key]) || 0;
        const arc = (value / t) * CIRCUMFERENCE;
        const dash = Math.max(0, arc - GAP);
        const seg = { key: cfg.key, color: cfg.color, dash, offset: -accumulated };
        accumulated += arc;
        return seg;
      });
    },
    legendItems() {
      return STATUS_CONFIG.map(cfg => ({
        key:   cfg.key,
        label: cfg.label,
        color: cfg.color,
        value: (this.metrics && this.metrics[cfg.key]) || 0,
      }));
    },
  },
};
</script>

<style scoped>
.donut-legend-wrap {
  display: flex;
  align-items: center;
  gap: 24px;
}
.donut-svg {
  flex-shrink: 0;
  overflow: visible;
}
.legend {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.legend-label {
  font-size: 12px;
  color: #555;
  font-family: Inter, sans-serif;
  flex: 1;
}
.legend-value {
  font-size: 12px;
  font-weight: 600;
  color: #1B1D21;
  font-family: Inter, sans-serif;
  min-width: 20px;
  text-align: right;
}
</style>
